<template>
  <el-form ref="form" :model="formData" :rules="configRules" label-width="180px" size="small" :validate-on-rule-change="false">
    <el-form-item v-if="isAddScheme" label="预计租赁周期" prop="rentPeriod" >
      <span v-if="formData.rentPeriodType === 3">{{formData.rentPeriod}}个月</span>
      <span v-else-if="formData.rentPeriodType === 1">{{formData.rentPeriod}}天</span>
    </el-form-item>
    <el-form-item v-if="configData.showFormItem.startStopDate && !isAddScheme" prop="startStopDate">
      <span slot="label">
        收款起止日期
        <el-popover
          :content="configData.popoverConfig.startStopDate"
          placement="top"
          :width="350"
          trigger="hover"
        >
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <span>
        {{`${formData.startTime && formData.startTime.split(' ')[0] || ''} 至 ${formData.endTime && formData.endTime.split(' ')[0] || ''}`}}
      </span>
    </el-form-item>
    <el-form-item v-if="configData.showFormItem.payMode" prop="payMode">
      <span slot="label">
        收款方式
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.payMode"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <el-select
        v-model="formData.payMode"
        :disabled="(configDisabled || payModeDisabled) && tempFormData.payMode"
        placeholder="请选择"
        @change="payModeChange"
      >
        <el-option
          v-for="item in paymentMethods"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <!-- 仅当收款方式选择为“月付（自然月）”或“月付（满月）”时，需展示并填写该字段。 -->
    <el-form-item
      v-if="
        configData.showFormItem.dailyRule &&
        [PAYMODE_CODE_MAP.FULL_MOON, PAYMODE_CODE_MAP.NATURAL_MONTH].includes(formData.payMode)
      "
      prop="dailyRule"
    >
      <span slot="label">
        不足月日租金规则
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.dailyRule"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <el-select
        size="small"
        v-model="formData.dailyRule"
        clearable
        :disabled="configDisabled && tempFormData.dailyRule"
        placeholder="请选择"
      >
        <el-option
          v-for="item in dailyRentRules"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <!-- 仅当收款方式选择为“月付（自然月）”或“月付（满月）”时，需展示并填写该字段。 -->
    <el-form-item
      v-if="
        configData.showFormItem.lastPeriodRule &&
        [PAYMODE_CODE_MAP.FULL_MOON, PAYMODE_CODE_MAP.NATURAL_MONTH].includes(formData.payMode)
      "
      prop="lastPeriodRule"
    >
      <span slot="label">
        不足月租金金额
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.lastPeriodRule"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <span>不足月日租金 x 天数</span>
    </el-form-item>
    <el-form-item v-if="configData.showFormItem.payPlanType"  prop="payPlanType">
      <span slot="label">
        收款金额
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.amount"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <!--
        月付（自然月）、月付（满月），支持两种模式：
          “固定方案”
          “阶梯方案”
        周付：不支持阶梯方案
        日付：不支持阶梯方案
          只需要填写日租金即可，注意文案和周付/月付有差异。
      -->
      <div
        v-if="
          configData.fundType === FEE_CODE_MAP.ZU_JIN &&
          [
            PAYMODE_CODE_MAP.WEEK,
            PAYMODE_CODE_MAP.FULL_MOON,
            PAYMODE_CODE_MAP.NATURAL_MONTH,
            ''
          ].includes(formData.payMode)"
        >
        <el-radio-group
          v-if="formData.payMode !== PAYMODE_CODE_MAP.WEEK"
          v-model="formData.payPlanType"
          :disabled="configDisabled && tempFormData.payPlanType"
        >
          <el-radio :label="0">固定方案</el-radio>
          <el-radio :label="1">阶梯方案(可配置阶梯区间:{{`${leaseSchemeMaxDate > 1 ? `${leaseSchemeMaxDate}月` : '不可配置'}`}})</el-radio>
        </el-radio-group>
        <!-- 固定方案 -->
        <div v-if="formData.payPlanType === PAYPLANTYPE_CODE_MAP.FIXED_SCHEME" class="amountType_box">
          <el-radio
            :disabled="configDisabled && tempFormData.amountType"
            class="amountType"
            :class="{amountError: rentPerPeriodError}"
            v-model="formData.amountType"
            :label="1"
            @change="amountTypeChange"
          >
            <el-form-item :error="rentPerPeriodError">
              每期总金额
              <el-input
                v-model="formData.rentPerPeriod"
                :disabled="configDisabled && tempFormData.rentPerPeriod"
                v-limit-money="true"
                placeholder="请输入"
                class="input"
                @input="rentPerPeriodChange"
              ></el-input>
              元
            </el-form-item>
          </el-radio>
          <el-radio
            :disabled="configDisabled && tempFormData.amountType"
            class="amountType"
            :class="{amountError: rentDayError}"
            v-model="formData.amountType"
            :label="2"
            @change="amountTypeChange"
          >
            <el-form-item :error="rentDayError">
              日租金
              <el-input
                v-model="formData.rentDay"
                :disabled="configDisabled && tempFormData.rentDay"
                v-limit-money="true"
                placeholder="请输入"
                class="input"
                @input="rentDayChange"
              ></el-input>
              元 x 每期自然天数
            </el-form-item>
          </el-radio>
        </div>
        <!-- 阶梯方案 -->
        <div v-if="formData.payPlanType === PAYPLANTYPE_CODE_MAP.LADDER_SCHEME" class="amountType_box">
          <el-radio
            class="amountType"
            v-model="formData.amountType"
            :label="1"
            :disabled="configDisabled && tempFormData.amountType"
          >每期总金额</el-radio>
          <!-- eslint-disable vue/no-unused-refs -->
          <LadderScheme
            v-if="formData.amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD"
            ref="amountPerPeriod"
            :configDisabled="configDisabled && tempFormData.amountType"
            :maxDate="leaseSchemeMaxDate"
            :amountType="formData.amountType"
            :piecewiseList="formData.piecewiseList"
          />
          <!-- eslint-enable vue/no-unused-refs -->
          <el-radio
            class="amountType"
            v-model="formData.amountType"
            :label="2"
            :disabled="configDisabled && tempFormData.amountType"
            >日租金元 x 每期自然天数</el-radio>
          <!-- eslint-disable vue/no-unused-refs -->
          <LadderScheme
            v-if="formData.amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT"
            ref="dailyRent"
            :configDisabled="configDisabled && tempFormData.amountType"
            :maxDate="leaseSchemeMaxDate"
            :amountType="formData.amountType"
            :piecewiseList="formData.piecewiseList"
          />
          <!-- eslint-enable vue/no-unused-refs -->
        </div>
      </div>
      <div v-else class="amount" :class="{amountError: amountError}">
        <el-form-item :error="amountError">
          {{formData.payMode === PAYMODE_CODE_MAP.DAY ? '日租金': formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE ? '' : '每期总金额'}}
          <el-input
            v-model="formData.amount"
            v-limit-money="true"
            :disabled="configDisabled && tempFormData.amount"
            placeholder="请输入"
            class="input"
            @input="amountChange"
          ><template slot="append">元</template></el-input>
        </el-form-item>
      </div>
    </el-form-item>
    <!--
      ● 月付：两个控件组成：
        ○ 下拉菜单，枚举值为 当期、下期。默认值为“当期”
        ○ 自定义文本输入框，hint 为“请输入 1-31 之间的数字”。无默认值。限制输入1-31 范围内的数字。为必填项。
      ● 周付：两个控件组成：
        ○ 下拉菜单，枚举值为 当期、下期。默认值为“当期”
        ○ 下拉菜单，枚举值为 周一至周日，无默认值，hint 为“请选择”，为必填项。
      ● 日付：展示固定文案“当日”。逻辑上日付每期的缴款日就是当日。
      ● 一次性：一个控件组成：
        ○ 下拉菜单，枚举值为 订单收款起始日、自定义。默认值为“订单收款起始日”
    -->
    <el-form-item v-if="configData.showFormItem.payDay" prop='payDay'>
      <span slot="label">
        缴款日
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.payDay"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <div
        v-if="[
          PAYMODE_CODE_MAP.WEEK,
          PAYMODE_CODE_MAP.FULL_MOON,
          PAYMODE_CODE_MAP.NATURAL_MONTH,
          PAYMODE_CODE_MAP.DISPOSABLE
        ].includes(formData.payMode) && delayPayFlagList.length > 0"
        class="payDay_box"
      >
        <el-select
          v-model="formData.payPost"
          placeholder="请选择"
          :disabled="configDisabled && tempFormData.payPost"
          class="delayPayFlag"
          @change="payPostChange"
        >
          <el-option
            v-for="item in delayPayFlagList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          class="ml8"
          v-if="
            formData.payMode === PAYMODE_CODE_MAP.WEEK &&
            ![PAYPOSY_CODE_MAP.CUSTOM, PAYPOSY_CODE_MAP.RECEIPT_START_DATE].includes(formData.payPost)
          "
          v-model="formData.payDay"
          :disabled="configDisabled && tempFormData.payDay"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in m_weekList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <el-input
          class="ml8"
          v-else-if="
            (formData.payMode === PAYMODE_CODE_MAP.FULL_MOON || formData.payMode === PAYMODE_CODE_MAP.NATURAL_MONTH) &&
            ![PAYPOSY_CODE_MAP.CUSTOM, PAYPOSY_CODE_MAP.RECEIPT_START_DATE].includes(formData.payPost)
          "
          v-interage="true"
          v-model="formData.payDay"
          :disabled="configDisabled && tempFormData.payDay"
          placeholder='请输入1-31之间的数字'
        ><template slot="append">日</template></el-input>
      </div>
      <div v-else-if="formData.payMode === PAYMODE_CODE_MAP.DAY">
        <span>当日</span>
      </div>
      <!-- 租金 || 其他 -->
      <el-date-picker
        v-else-if="
          configData.fundType === FEE_CODE_MAP.ZU_JIN ||
          configData.fundType === FEE_CODE_MAP.OTHERS ||
          (formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE && formData.payPost === PAYPOSY_CODE_MAP.CUSTOM)
        "
        v-model="formData.customerDueDate"
        :disabled="configDisabled && tempFormData.customerDueDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="date"
        placeholder="选择日期时间"
      ></el-date-picker>
      <span v-else>{{formData.startTime && formData.startTime.split(' ')[0] || ''}}</span>
    </el-form-item>
    <el-form-item v-if="configData.showFormItem.advancePayment && formData.payMode !== ''" prop="advancePayment">
      <span slot="label">
        发车前收款
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.advancePayment"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <el-select
        size="small"
        v-model="formData.advancePayment"
        :disabled="(configDisabled && tempFormData.advancePayment) || advancePaymentDisabled"
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="item in filterAdvancePayment(advancePayment)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <!-- 仅当收款方式选择为“月付（自然月）”或“月付（满月）”或“周付”时，需展示并填写该字段。 -->
    <el-form-item
      v-if="
        configData.showFormItem.amountAccuracy &&
        [PAYMODE_CODE_MAP.WEEK, PAYMODE_CODE_MAP.FULL_MOON, PAYMODE_CODE_MAP.NATURAL_MONTH].includes(formData.payMode)
      "
      prop="amountAccuracy"
    >
      <span slot="label">
        收款金额保留位数
        <el-popover
          placement="top"
          :width="350"
          trigger="hover"
        >
          <span v-html="configData.popoverConfig.amountAccuracy"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <el-radio-group v-model="formData.amountAccuracy" :disabled="(configDisabled && tempFormData.amountAccuracy)">
        <el-radio :label="0">金额取整</el-radio>
        <el-radio :label="2">金额保留两位小数</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- 新滞纳金表单项-start -->
    <el-form-item v-if="configData.showFormItem.lateFeeProportion" prop="lateFeeProportion">
      <span slot="label">
        收取比例
        <el-popover placement="top" :width="350" trigger="hover">
          <span v-html="configData.popoverConfig.lateFeeProportion"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      每日未付租金*
      <el-input :disabled="configDisabled" placeholder='请输入' v-number:percent v-model="formData.lateFeeProportion" />
      %
    </el-form-item>
    <el-form-item v-if="configData.showFormItem.interestFreeDays" prop="interestFreeDays">
      <span slot="label">
        免息天数
        <el-popover placement="top" :width="350" trigger="hover">
          <span v-html="configData.popoverConfig.interestFreeDays"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </span>
      <el-input :disabled="configDisabled" placeholder='限制0-365之间数字' v-model="formData.interestFreeDays" />
      日
    </el-form-item>
    <!-- 新滞纳金表单项-end -->
  </el-form>
</template>

<script>
import { ADVANCEPAYMENT_CODE_MAP, AMOUNTTYPE_CODE_MAP, FEE_CODE_MAP, PAYMODE_CODE_MAP, PAYPLANTYPE_CODE_MAP, PAYPOSY_CODE_MAP } from '@/store/dict/rentPlanDict'
import selectOption from '@/store/dict/selectOptionDict'
import config from '../config'
import LadderScheme from './LadderScheme.vue'

export default {
  components: {
    LadderScheme,
  },
  props: {
    tempFormData: {
      type: Object,
      default: () => ({}),
    },
    configData: {
      type: Object,
      default: () => ({}),
    },
    leaseSchemeMaxDate: {
      type: Number,
      default: 0,
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
    isAddScheme: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const {
      // 校验
      configRules,
      paymentMethodsList,
    } = config.call(this)
    return {
      PAYMODE_CODE_MAP,
      PAYPOSY_CODE_MAP,
      PAYPLANTYPE_CODE_MAP,
      AMOUNTTYPE_CODE_MAP,
      FEE_CODE_MAP,
      configRules,
      paymentMethodsList,
      // 周付 缴款日下拉列表
      m_weekList: [
        {
          code: 1,
          name: '每周一',
        },
        {
          code: 2,
          name: '每周二',
        },
        {
          code: 3,
          name: '每周三',
        },
        {
          code: 4,
          name: '每周四',
        },
        {
          code: 5,
          name: '每周五',
        },
        {
          code: 6,
          name: '每周六',
        },
        {
          code: 7,
          name: '每周日',
        },
      ],
      rentPerPeriodError: '',
      rentDayError: '',
      amountError: '',
      formData: {},
    }
  },
  computed: {
    // 日租金规则
    dailyRentRules() {
      return this.dictParseList(selectOption.dailyRentRules)
    },
    // 发车前收款
    advancePayment() {
      return this.dictParseList(selectOption.advancePayment)
    },
    // 缴款日
    delayPayFlagList() {
      if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        return this.delayPayFlagListForDisposable
      } else {
        return this.delayPayFlagListForWeekMonth
      }
    },
    // 新增(编辑)租赁方案模板时，收款方式：周付、月付，缴款日：当期、下期、自定义
    // 使用租赁方案模板时，收款方式：周付、月付，缴款日：当期、下期
    delayPayFlagListForWeekMonth() {
      return this.dictParseList(selectOption.delayPayFlagList).filter((item) => {
        if (this.isAddScheme) {
          return [PAYPOSY_CODE_MAP.CURRENT_PERIOD, PAYPOSY_CODE_MAP.NEXT_PERIOD, PAYPOSY_CODE_MAP.CUSTOM].includes(item.value)
        } else {
          return [PAYPOSY_CODE_MAP.CURRENT_PERIOD, PAYPOSY_CODE_MAP.NEXT_PERIOD].includes(item.value)
        }
      })
    },
    // 新增(编辑)租赁方案模板时，收款方式：一次性，缴款日：订单收款起始日、自定义
    // 使用租赁方案模板时，收款方式：一次性，缴款日：订单收款起始日
    delayPayFlagListForDisposable() {
      return this.dictParseList(selectOption.delayPayFlagList).filter((item) => {
        if (this.isAddScheme) {
          return [PAYPOSY_CODE_MAP.CUSTOM, PAYPOSY_CODE_MAP.RECEIPT_START_DATE].includes(item.value)
        } else {
          return false
        }
      })
    },
    // 发车前收款置灰
    advancePaymentDisabled() {
      // ● 收款方式为“一次性”：默认为“收取全部”，纯文本展示，不可编辑。收取全部 == 发车前需要收齐。
      // ● 收款方式非“一次性”：
      //   ○ 如果缴款日为当期日期，则下拉控件展示，枚举值为“收取首期、发车前不收”，默认值为“收取首期”。
      //   ○ 如果缴款日为下期日期，则纯文本展示为“发车前不收”，且不可编辑
      let flag = false
      const { fundType } = this.configData
      const { payPost, payMode } = this.formData
      if (payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        flag = true
      }
      if (fundType !== FEE_CODE_MAP.ZU_JIN && fundType !== FEE_CODE_MAP.OTHERS) {
        flag = true
      }
      if ((fundType === FEE_CODE_MAP.ZU_JIN || fundType === FEE_CODE_MAP.OTHERS) && payPost === PAYPOSY_CODE_MAP.NEXT_PERIOD) {
        flag = true
      }
      return flag
    },
    // 收款方式置灰
    payModeDisabled() {
      const { fundType } = this.configData
      return fundType === FEE_CODE_MAP.SHOU_FU_KUAN || fundType === FEE_CODE_MAP.QUAN_KUAN || fundType === FEE_CODE_MAP.DING_JIN || fundType === FEE_CODE_MAP.BAO_ZHENG_JIN || fundType === FEE_CODE_MAP.ZHI_NA_JIN || fundType === FEE_CODE_MAP.WEI_KUAN
    },
    // 收款方式列表
    paymentMethods() {
      const { fundType } = this.configData
      const { list } = this.paymentMethodsList.find((item) => {
        return item.code === fundType
      })
      return list
    },
  },
  methods: {
    amountTypeChange() {
      this.rentDayError = ''
      this.rentPerPeriodError = ''
      this.formData.rentPerPeriod = null
      this.formData.rentDay = null
    },
    amountChange() {
      if (!this.formData.amount) {
        this.amountError = '请输入金额'
      } else {
        this.amountError = ''
      }
    },
    rentDayChange() {
      if (!this.formData.rentDay && this.formData.amountType === 2) {
        this.rentDayError = '请输入金额'
      } else {
        this.rentDayError = ''
      }
    },
    rentPerPeriodChange() {
      if (!this.formData.rentPerPeriod && this.formData.amountType === 1) {
        this.rentPerPeriodError = '请输入金额'
      } else {
        this.rentPerPeriodError = ''
      }
    },
    // 过滤发车前收款
    filterAdvancePayment(list) {
      const { fundType } = this.configData
      const { payMode, payPost } = this.formData
      /**
       * 收款方式为“一次性”时：默认为“收取全部”，纯文本展示，不可编辑
       * 收款方式为“非一次性”时：
       * ○ 如果缴款日为“当期”或“自定义”，则下拉控件展示“收取首期、发车前不收”，默认值为“收取首期”。
       * ○ 如果缴款日为“下期”，则纯文本展示为“发车前不收”，且不可编辑
       */
      if ((fundType === FEE_CODE_MAP.ZU_JIN || fundType === FEE_CODE_MAP.OTHERS) && payMode !== PAYMODE_CODE_MAP.DISPOSABLE) {
        if (payPost === PAYPOSY_CODE_MAP.CURRENT_PERIOD || payPost === PAYPOSY_CODE_MAP.CUSTOM) {
          list = list.slice(0, 2)
          return list
        } else {
          this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.NOT_ACCEPT
        }
      }

      return list
    },
    // eslint-disable-next-line vue/no-unused-properties
    init() {
      this.$refs.form.clearValidate()
      this.formData = {}
      const formData = Object.assign(this.formData, this.configData.formData)
      this.formData = Object.assign(this.configData.formData, formData)
      if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        // 为了兼容历史数据，这里不管租赁方案是旧版还是新版，只要是“一次性“支付方式就强制改为“收取全部”
        this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.ALL
      }
    },
    // 收款方式改变
    payModeChange() {
      this.$refs.form.clearValidate()
      this.formData.payDay = ''
      this.formData.customerDueDate = ''
      this.formData.amountAccuracy = 2
      this.payModeInit()
    },
    /**
     * 不同收款方式对应不同的发车前收款 缴款日等设置的限制
     */
    payModeInit() {
      if (this.formData.payMode === PAYMODE_CODE_MAP.DAY) {
        // 缴款日： 日付：展示固定文案“当日”。逻辑上日付每期的缴款日就是当日。
        this.formData.payDay = '当日'
        this.formData.payPlanType = PAYPLANTYPE_CODE_MAP.FIXED_SCHEME
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
        this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.FIRST_PERIOD
      } else if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        // 发车前收款：收款方式为“一次性”：默认为“收取全部”，纯文本展示，不可编辑。收取全部 == 发车前需要收齐。
        // 缴款日： 一次性：日期控件 可以选择某个日期。不限制可选择日期的起止。
        this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.ALL
        this.formData.payPost = PAYPOSY_CODE_MAP.RECEIPT_START_DATE
        this.formData.payDay = this.formData.startTime
        this.formData.customerDueDate = this.formData.startTime
        this.formData.payPlanType = PAYPLANTYPE_CODE_MAP.FIXED_SCHEME
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
      } else if (this.formData.payMode === PAYMODE_CODE_MAP.WEEK) {
        this.formData.payPost = PAYPOSY_CODE_MAP.CURRENT_PERIOD
        this.formData.payPlanType = PAYPLANTYPE_CODE_MAP.FIXED_SCHEME
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
        this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.FIRST_PERIOD
      } else {
        // 收款方式非“一次性”：如果缴款日为当期日期，则下拉控件展示，枚举值为“收取首期、发车前不收”，默认值为“收取首期”。
        this.formData.payPost = PAYPOSY_CODE_MAP.CURRENT_PERIOD
        this.formData.advancePayment = ADVANCEPAYMENT_CODE_MAP.FIRST_PERIOD
      }

      const { fundType, payMode } = this.formData
      if ((fundType === FEE_CODE_MAP.ZU_JIN || fundType === FEE_CODE_MAP.OTHERS) && [PAYMODE_CODE_MAP.WEEK, PAYMODE_CODE_MAP.FULL_MOON, PAYMODE_CODE_MAP.NATURAL_MONTH].includes(payMode)) {
        this.formData.amountAccuracy = 0
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 缴款日改变
    payPostChange() {
      this.formData.payDay = ''
      this.formData.customerDueDate = ''
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-form-item {
    display: flex;
    margin-bottom: 12px;
  }
  ::v-deep .el-form-item__label {
    float: none
  }
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
  }
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
  ::v-deep .el-input-group--append {
    width: 200px;
  }
  ::v-deep .el-input {
    width: 170px;
  }
  ::v-deep .el-input__inner {
    width: 170px;
  }
  .amountType_box {
    margin-top: 6px;
    padding-left:  20px;
    .amountType {
      width: 70%;
      margin-bottom: 6px;

      ::v-deep .el-form-item {
        margin-bottom: 0;
      }
    }

    .amountError {
      margin-bottom: 20px;
    }

    .input {
      width: 100px;
    }

    ::v-deep .el-input__inner {
      width: 100px;
    }
  }
  .payDay_box {
    display: flex;
    .delayPayFlag {

    }
  }
  .amount {
    display: flex;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    .amountError {
      margin-bottom: 20px;
    }

    .amount_tips {
      white-space: nowrap;
    }
  }
  .ml8 {
    margin-left: 8px;
  }
</style>
